import gql from 'graphql-tag';

import { ProLicense } from '@/interfaces/ProLicense';

import lightStateFields from '@/queries/fields/lightStateFields';
import sensorSettingsFields from '@/queries/fields/sensorSettingsFields';
import proLicenseFields from '@/queries/fields/proLicenseFields';
import { DeviceModel } from '@/queries/fields/DeviceModel';
import { WizclickFields } from '@/queries/fields/wizclickFields';

const lightFields = gql`
  fragment lightFields on Light {
    id
    name
    type
    displayOrder
    provider
    macAddress
    iconPath
    isRetrofitIcon
    iconId
    ip
    creationDate
    updateDate
    model {
      ...deviceModelFragment
    }
    groupId
    roomId
    floorId
    isConnected: connectionStatus
    fadeIn
    fadeOut
    startupMode
    defaultDimming
    fwVersion
    operationMode
    currentState {
      ...lightStateFields
    }
    position {
      id
      coordX
      coordY
    }
    proLicense {
      activated
      type
      activationCost
    }
    sensorSettings {
      ...sensorSettingsFields
    }
    rssi
    customPowerConsumption
    pwmMin
    pwmMax
    wiFiCredentialsUpdateState {
      status
      updateDate
    }
    wizclick1 {
      ...wizclickSettingsFields
    }
    wizclick2 {
      ...wizclickSettingsFields
    }
  }
  ${lightStateFields}
  ${sensorSettingsFields}
  ${DeviceModel.fragment}
  ${WizclickFields.fragment}
`;

export interface LightLifetimeFragmentData {
  id: string;
  macAddress: string;
  model: {
    id: string;
    lifetime: number;
  };
  isConnected: boolean;
  proLicense: ProLicense;
}
export const lightLifetimeFragment = gql`
  fragment lightLifetimeFragment on Light {
    id
    macAddress
    model {
      id
      lifetime
    }
    isConnected: connectionStatus
    proLicense {
      ...proLicenseFields
    }
  }
  ${proLicenseFields}
`;

export default lightFields;
